import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_CAN_VIEW_MARKETPLACE,
    CLEAR_CAN_VIEW_MARKETPLACE_ERROR,
    LOAD_CAN_VIEW_MARKETPLACE_REQUEST,
    LOAD_CAN_VIEW_MARKETPLACE_SUCCESS,
    LOAD_CAN_VIEW_MARKETPLACE_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_CAN_VIEW_MARKETPLACE,
    CLEAR_ERROR: CLEAR_CAN_VIEW_MARKETPLACE_ERROR,
    LOAD_REQUEST: LOAD_CAN_VIEW_MARKETPLACE_REQUEST,
    LOAD_SUCCESS: LOAD_CAN_VIEW_MARKETPLACE_SUCCESS,
    LOAD_FAILURE: LOAD_CAN_VIEW_MARKETPLACE_FAILURE
}